import { render } from "./specialList.vue?vue&type=template&id=1c61081a&scoped=true"
import script from "./specialList.vue?vue&type=script&lang=js"
export * from "./specialList.vue?vue&type=script&lang=js"

import "./specialList.vue?vue&type=style&index=0&id=1c61081a&lang=scss&scoped=true"

import exportComponent from "E:\\wwwroot\\qifu-web-v1.0.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c61081a"]])

export default __exports__